import {
  addDoc,
  CollectionReference,
  serverTimestamp,
} from 'firebase/firestore'
import { useState } from 'react'
import { HelpItem } from '../types'

export const useAddHelpItem = (col: CollectionReference<HelpItem>) => {
  const [question, setQuestion] = useState('')
  const [answer, setAnswer] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    await addDoc(col, { question, answer, createdAt: serverTimestamp() })
    setQuestion('')
    setAnswer('')
  }

  return {
    question,
    answer,
    setQuestion,
    setAnswer,
    handleSubmit,
  }
}
